import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Button, Icon, Label, Popup } from 'semantic-ui-react';
import { gql, useMutation } from "@apollo/client";

const LikeButton = ({ user, post: { id, likeCount, likes } }) => {
    const [liked, setLiked] = useState(false);

    useEffect(() => {
        setLiked(user && likes.find(like => like.username === user.username));
    }, [user, likes]);

    const [likePost] = useMutation(LIKE_POST_MUTATION, {
        variables: { postId: id }
    });

    const likeButton = user ? (
        liked ? (
            <Button icon color='teal'>
                <Icon name='heart' />
            </Button>
        ) : (
            <Button icon color='teal' basic>
                <Icon name='heart' />
            </Button>
        )
    ) : (
        <Button as={Link} to="/login" icon color='teal' basic>
            <Icon name='heart' />
        </Button>
    )

    return (
        <Popup content={user ? (liked ? "Je n'aime plus" : "J'aime") : "Se connecter pour pouvoir liker"} inverted trigger={
            <Button data-testid='likebutton' as='div' labelPosition='right' onClick={likePost} >
                {likeButton}
                <Label basic color='teal' pointing='left'>
                    {likeCount}
                </Label>
            </Button>
        }
        />
    )
}

export const LIKE_POST_MUTATION = gql`
    mutation likePost($postId: ID!){
        likePost(postId: $postId){
            id
            likes{
                id username
            }
            likeCount
        }
    }
`

export default LikeButton;